"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importDefault(require("react"));
function JetAuthenticationCardLogo() {
    return (react_1.default.createElement(inertia_react_1.InertiaLink, { href: "/" },
        react_1.default.createElement("img", { src: "/images/logo.svg", style: { width: "100px" } })));
}
exports.default = JetAuthenticationCardLogo;
